// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"403":"b44cc871","453":"558a987e"}[chunkId] + ".chunk.js";
};